import _ from './underscore-wrapper';

function changeEventString(doWhen) {
  return 'change:' + _.keys(doWhen).join(' change:');
}

function calcDoWhen(value, key) {
  const modelValue = this.model.get(key);

  if (_.isFunction(value)) {
    return value.call(this, modelValue);
  } else {
    return value === modelValue;
  }
}

function _doWhen(view, doWhen, fn) {
  const toggle = _.bind(fn, view, view, doWhen);

  view.render = _.wrap(view.render, function (render) {
    const val = render.call(view);

    toggle({ animate: false });
    return val;
  });

  view.listenTo(view.model, changeEventString(doWhen), function () {
    toggle({ animate: true });
  });
}

export default {
  applyDoWhen: function (view, doWhen, fn) {
    if (!(view.model && _.isObject(doWhen) && _.size(doWhen) && _.isFunction(fn))) {
      return;
    }
    _doWhen(view, doWhen, function (view, doWhen, options) {
      const result = _.every(_.map(doWhen, calcDoWhen, view));

      fn.call(view, result, options);
    });
  }
};



// WEBPACK FOOTER //
// /Users/aarongranick/okta/okta-ui/packages/courage/src/util/ViewUtil.js


// WEBPACK FOOTER //
// webpack:///Users/aarongranick/okta/okta-ui/packages/courage/src/util/ViewUtil.js